<template>
  <div>
    <b-container class="article">
      <b-row>
        <b-col>
          <b-card no-body>
            <puls-card-header
              :title="article.title"
              :left-action="{
                to: {
                  name: 'Section',
                  title: sectionTitle,
                  params: { section: sectionName }
                }
              }"
            />
            <b-card-body>
              <markdown-it-vue :content="article.body" />
              <iframe
                v-if="article.iframe"
                :src="article.iframe"
                width="100%"
                height="100%"
                style="height: 800px; border: 0px"
              ></iframe>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import en from '../locales/en'
export default {
  name: 'Article',
  data: () => {
    return {
      iframeLoading: true
    }
  },
  computed: {
    sectionName() {
      return this.$route.params.section
    },
    sectionTitle() {
      return this.$t(`home.sections.${this.sectionName}.title`)
    },
    articleName() {
      return this.$route.params.article
    },
    article() {
      const article = Object.keys(
        en.home.sections[this.sectionName].articles[this.articleName]
      ).reduce((res, key) => {
        res[key] = this.$t(
          `home.sections.${this.sectionName}.articles.${this.articleName}.${key}`
        )
        return res
      }, {})
      return article
    }
  },
  methods: {
    onLoad() {
      this.iframeLoading = false
    }
  }
}
</script>

<style>
.markdown-body > h1 {
  font-size: 2.1em;
  font-weight: 100;
}

.markdown-body > h2 {
  font-size: 1.9em;
  font-weight: 100;
}

.markdown-body > h3 {
  font-size: 1.5rem !important;
  font-weight: 500 !important;
}

.markdown-body > ol {
  font-size: 16px;
  line-height: 28px;
}

.markdown-body {
  font-size: 15px;
  line-height: 22px;
  margin-left: 18px;
  margin-right: 18px;
}

.markdown-body > img,
.markdown-body > div > img {
  max-width: 70%;
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 40px;
}

.markdown-body a {
  color: #f4b741;
}
.markdown-body {
  color: var(--kt-text-gray-900);
  margin-top: 0px !important;
}
</style>

<style>
.card-body {
  margin-left: 0px !important;
}
</style>
